orderPrintDocumentsService.$inject = ["$http"];
/* @ngInject */
function orderPrintDocumentsService($http) {
  var service = this;
  service.getLegalDocumentAll = orderNumber => {
    return $http.get('printDocument/getLegalDocumentAll', {
      params: {
        orderNumber: orderNumber
      }
    }).then(function (response) {
      return response.data;
    });
  };
  service.getLegalDocumentWhenPaying = orderNumber => {
    return $http.get('printDocument/getLegalDocumentWhenPaying', {
      params: {
        orderNumber: orderNumber
      }
    }).then(function (response) {
      return response.data;
    });
  };
}
export default orderPrintDocumentsService;